import {
  PERSONALTASKUSED_FETCHING,
  PERSONALTASKUSED_SUCCESS,
  PERSONALTASKUSED_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PERSONALTASKUSED_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PERSONALTASKUSED_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PERSONALTASKUSED_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
